import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'mercado',
    loadComponent: () => import('./dashboard/pages/marketplace/marketplace.component').then(m => m.MarketplaceComponent)
  },
  {
    path: 'mercado/:id',
    loadComponent: () => import('./dashboard/pages/marketplace/product-detail/product-detail.component').then(m => m.ProductDetailComponent)
  },
  {
    path: 'broker',
    loadComponent: () => import('./pages/broker/broker.component').then(m => m.BrokerComponent)
  },
  {
    path: 'logistica',
    loadComponent: () => import('./pages/logistica/logistica.component').then(m => m.LogisticaComponent)
  },
  {
    path: 'nosotros',
    loadComponent: () => import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'contacto',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent)
  },
  {
    path: 'como-funciona',
    loadComponent: () => import('./pages/how-it-works/how-it-works.component').then(m => m.HowItWorksComponent)
  },
  {
    path: 'politicas-privacidad',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terminos-condiciones',
    loadComponent: () => import('./pages/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent)
  },
  {
    path: 'documentos-legales',
    loadComponent: () => import('./pages/legal-documents/legal-documents.component').then(m => m.LegalDocumentsComponent)
  },
  {
    path: 'planes',
    loadComponent: () => import('./pages/memberships/memberships.component').then(m => m.MembershipsComponent)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.dashboardRoutes),
    canActivate: [authGuard]
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
